<template>
  <el-dialog class="detailsDialog" width="1080px" title="赊账记录" :visible.sync="form.dialog" :append-to-body="true">
    <div class="commonInfo">
      <div class="content" style="margin: 0 0 10px 0;">
        <h3>姓名：{{ nickName }}</h3>
        <h3>会员卡号：{{ cardNo }}</h3>
        <h3>联系电话：{{ userPhone ? Lib.starPhone(userPhone) : '--' }}</h3>
        <!-- <h3>总赊账：{{ form.totalMoney ? form.totalMoney.toFixed(2) : '0.00' }}元</h3>
        <h3>已还款：{{ form.refundMoney ? form.refundMoney.toFixed(2) : '0.00' }}元</h3>
        <h3>未还款：{{ form.unRefundMoney ? form.unRefundMoney.toFixed(2) : '0.00' }}元</h3> -->
      </div>
    </div>
    <div class="block">
      <el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" :editable="false" @change="search">
      </el-date-picker>
      <el-input v-model.trim="inputVal" class="width_200 ml_20" placeholder="请输入订单号进行搜索" @keyup.enter.native="search">
        <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="search"></i>
      </el-input>
    </div>
    <div style="margin-top: 15px;">
      <el-table :data="recordList" tooltip-effect="light">
        <el-table-column prop="serveDateStr" label="赊账时间" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="orderCode" label="订单号" width="180" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="itemName" label="服务项目" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.itemName">{{ scope.row.itemName }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="productName" label="产品购买" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.productName">{{ scope.row.productName }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="total" label="赊账金额（元）" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.total">{{ scope.row.total.toFixed(2) }}</span>
            <span v-else>0.00</span>
          </template>
        </el-table-column>
        <el-table-column prop="refundTotal" label="已还金额（元）" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.refundTotal">{{ scope.row.total.toFixed(2) }}</span>
            <span v-else>0.00</span>
          </template>
        </el-table-column>
        <el-table-column prop="noRefundTotal" label="未还金额（元）" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.noRefundTotal">{{ scope.row.total.toFixed(2) }}</span>
            <span v-else>0.00</span>
          </template>
        </el-table-column>
        <el-table-column prop="accountName" label="结算人员">
          <template slot-scope="scope">
            <span>{{ scope.row.accountName || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dutyName" label="授权人">
          <template slot-scope="scope">
            <span>{{ scope.row.dutyName || '--' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="recordList.length > 0" class="fn_foot">
        <span>合计</span>
        <samp>{{ billInfo.total }}</samp>
        <samp>{{ billInfo.refundTotal }}</samp>
        <label>{{ billInfo.noRefundTotal }}</label>
      </div>
    </div>
    <div v-if="recordList.length > 0" class="blockThree">
      <el-pagination background :current-page.sync="pageNum" :page-size="10" layout="prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import { getBillRecord, getMemberInfo, getAccountListByCustomerSum } from './api/index';

export default {
  data() {
    return {
      cardNo: '', // 会员卡号
      ctName: '', // 会员名称
      nickName: '', // 会员昵称
      userPhone: '', // 联系电话
      inputVal: '', // 搜索值
      date: '',
      pageNum: 1,
      rowCount: 1,
      recordList: [], // 赊账记录
      form: {
        // 赋值数据
        memberId: '',
        phone: '',
        totalMoney: '', // 总赊账
        refundMoney: '', // 已还款
        unRefundMoney: '', // 未还款
        dialog: false
      },
      // 5.9
      pickerOptions: { // 只能选择今天之前的时间
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      billInfo: {}
    };
  },
  // 监听会员ID的变化
  watch: {
    'form.dialog': function (val) {
      if (val) {
        const vm = this;
        vm.inputVal = '';
        vm.pageNum = 1;
        vm.getUserInfo();
        vm.getListData();
      }
    }
  },
  mounted() {
    const vm = this;
    vm.$emit('billRecord', vm.form);
  },
  methods: {
    // 搜索--赊账记录
    search() {
      this.Lib.keyboardBlur();
      const vm = this;
      vm.Lib.keyboardBlur();
      vm.pageNum = 1;
      vm.getListData();
    },
    handleSizeChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    // 赊账记录列表
    getListData() {
      const vm = this;
      const data = {
        keyWord: vm.inputVal,
        phone: vm.form.phone,
        pageNum: vm.pageNum,
        pageSize: 10,
        startDate: vm.date ? vm.date[0] : null,
        endDate: vm.date ? vm.date[1] : null,
      };
      const dataTwo = {
        keyWord: vm.inputVal,
        phone: vm.form.phone,
        startDate: vm.date ? vm.date[0] : null,
        endDate: vm.date ? vm.date[1] : null,
      };
      getBillRecord(data).then((res) => {
        vm.recordList = res.data.records;
        vm.rowCount = res.data.total;
      });
      getAccountListByCustomerSum(dataTwo).then((res) => {
        if (res.code == 0) {
          this.billInfo = res.data;
        } else {
          console.log(res);
        }
      });
    },
    // 获取个人信息
    getUserInfo() {
      const vm = this;
      const data = {
        keyWord: vm.form.phone
      };
      getMemberInfo(data).then((res) => {
        vm.cardNo = res.data.cardNo;
        vm.ctName = res.data.ctName;
        vm.nickName = res.data.nickName;
        vm.userPhone = res.data.phone;
      });
    }
  }
};
</script>
